import GeneralDialog from './general-dialog';
import ChangeLogDialog from './change-log-dialog';
import { Dispatch, SetStateAction } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface ConfirmMoveDocDialogProps {
  open: boolean;
  openChangeLogDialog: boolean;
  setOpenChangeLogDialog: Dispatch<SetStateAction<boolean>>;
  changeLogMessage: string;
  setChangeLogMessage: Dispatch<SetStateAction<string>>;
  handleClose: () => void;
  selectedFolder: string;
  mutate: () => void;
  mutateLoading: boolean;
}

export default function ConfirmMoveDocDialog({
  open,
  openChangeLogDialog,
  setOpenChangeLogDialog,
  changeLogMessage,
  setChangeLogMessage,
  handleClose,
  selectedFolder,
  mutate,
  mutateLoading,
}: ConfirmMoveDocDialogProps) {
  return (
    <GeneralDialog
      open={open}
      handleClose={() => {
        handleClose();
      }}
      maxWidth={'xs'}
      title={'Confirm Move Document/s'}
      dialogContent={
        <Box>
          <Stack
            sx={{ px: 2, minHeight: 70, justifyContent: 'center' }}
            gap={2}
          >
            <Typography sx={{ fontSize: 14 }} textAlign={'center'}>
              Are you sure you want to move the selected item(s) to{' '}
              <b>{selectedFolder}</b>? Everyone who can see{' '}
              <b>{selectedFolder}</b> will gain access.
            </Typography>
          </Stack>
          <ChangeLogDialog
            open={openChangeLogDialog}
            handleClose={() => setOpenChangeLogDialog(false)}
            changeLogMessage={changeLogMessage}
            setChangeLogMessage={setChangeLogMessage}
            mutate={mutate}
            mutateLoading={mutateLoading}
          />
        </Box>
      }
      primaryButton={{
        loading: mutateLoading,
        action: mutate,
        disabled: mutateLoading,
        title: 'Confirm',
      }}
    />
  );
}
